import {FC} from 'react';

import Button from '@/shared/components/button';
import {localize} from '@/shared/services/i18n';

import RegisterMembersCard from '../RegisterMembersCard';
import {LOGIN_MEMBERS_CARD} from './consts';

interface MembersSectionProps {
  handleSignInWithEmail: () => void;
}

const MembersSection: FC<MembersSectionProps> = ({handleSignInWithEmail}) => {
  return (
    <section className="flex flex-col items-center gap-12 bg-light-primary px-4 py-14 sm:gap-14 sm:px-12 sm:py-20">
      <h3 className="text-center font-bold text-3xl max-sm:text-2xl">
        {localize('landing_members_forever_title')}
      </h3>
      <div className="grid items-start gap-12 sm:grid-cols-2 sm:gap-8 xl:flex">
        {LOGIN_MEMBERS_CARD.map((card) => (
          <RegisterMembersCard
            key={card.name}
            image={card.image}
            text={localize(card.textKey)}
            name={card.name}
            firstCode={card.firstCode}
            secondCode={card.secondCode}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="fit"
        className="w-full max-w-96"
      >
        {localize('landing_try_now_label')}
      </Button>
    </section>
  );
};

export default MembersSection;
